import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { map, filter, scan } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LocalStorageService } from '../storage/localstorage.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})

export class ParameterService {


  constructor(private http: HttpClient) {

  }

  //programme


  addMachine(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/machine', item);
  }

  saveMachineLocation(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/location', item);
  }
  addProduit(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/produit', item);
  }

  addMesure(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'params/unite-mesure', item);
  }

  addCooperative(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/cooperative', item);
  }
  editMachine(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-machine`, item);
  }
  editCooperative(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-cooperative`, item);
  }
  editProduit(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-produit`, item);
  }

  updateCategorieMarket(ref: any, item: any): Observable<any> {
    return this.http.put(environment.apiUrl + `params/categorie-produit/` + ref, item);
  }
  editMesure(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `params/update-unite`, item);
  }
  deleteMachine(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/remove-machine`, item);
  }

  rendreDisponibleMachine(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/machine/rendre-disponible`, item);
  }
  deleteProduit(item: any): Observable<any> {

    return this.http.post(environment.apiUrl + `operation/remove-produit`, item);
  }
  deleteCooperative(item: any): Observable<any> {

    return this.http.post(environment.apiUrl + `operation/remove-cooperative`, item);
  }

  deleteCategorie(item: any): Observable<any> {

    return this.http.delete(environment.apiUrl + `params/categorie-produit/` + item);
  }

  deleteUniteMesure(item: any): Observable<any> {

    return this.http.post(environment.apiUrl + `params/remove-unite`, item);
  }
  //
  searchByPeriode(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/filtre-locations'}`, item);
  }

  //
  getMachine(): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/machines`);
  }
  getParametrageProduit(): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/produits`);
  }

  getDemandeLocation(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/historique-locations`);
  }

  getMembres(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/membres`);
  }

  getAgents(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/agents`);
  }

  getStock(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `params/stocks`, item);
  }
  getPays(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/pays`);
  }
  getCooperative(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/cooperatives`);
  }
  getAgriculteur(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'params/membres');
  }

  //
  getTypeMachine(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/types-machine`);
  }

  getCategorieProduit(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/categories_produits`);
  }
  getAccessoire(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/accessoires-compatibles`);
  }
  getUniteMesure(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/unites-mesure`);
  }
  getEtat(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/etats-machines`);
  }


  getEtatProduit(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/etats-produits`);
  }
  getVarieteProduit(): Observable<any> {
    return this.http.get(environment.apiUrl + `params/varietes-produits`);
  }
  //
  getCommunesByDepartement(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/communes/${id}`);
  }

  getArrondissementsByCommune(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/arrondissements/${id}`);
  }
  getVilleById(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'params/villes/' + id);

  }

  getCoopById(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'params/cooperatives/' + id);

  }

  getDashboard(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + 'operation/superadmin/dashboard/' + id);

  }

  getCategorieProduitMarket(): Observable<any> {
    return this.http.get(environment.apiUrl + 'params/categories_produits');

  }


  addCategorieMarket(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/cooperative', item);
  }
}


